module.exports = __webpack_public_path__ + "img/clipboard.3a6ac1ab.svg";